import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Loader = ({ onLoadingComplete }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev < 70) return prev + 5;
        if (prev < 90) return prev + 2;
        if (prev < 99) return prev + 1;

        clearInterval(progressInterval);

        setTimeout(() => {
          setProgress(100);

          setTimeout(() => {
            setIsLoading(false);
          }, 400);
        }, 500);

        return 99;
      });
    }, 40);

    return () => clearInterval(progressInterval);
  }, []);

  return (
    <AnimatePresence onExitComplete={onLoadingComplete}>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{
            opacity: 0,
            scale: 1.15,
            filter: "blur(20px)",
          }}
          transition={{
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-background-dark overflow-hidden"
        >
          {/* Background Glow */}
          <div className="absolute inset-0 flex items-center justify-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{
                opacity: 0.25,
                scale: 1,
              }}
              transition={{
                duration: 2,
                ease: "easeOut",
              }}
              className="absolute w-[400px] h-[400px] md:w-[550px] md:h-[550px] bg-gold rounded-full blur-[140px]"
            />
          </div>

          {/* Rotating Ring */}
          <motion.div
            animate={{
              rotate: 360,
            }}
            transition={{
              duration: 25,
              repeat: Infinity,
              ease: "linear",
            }}
            className="absolute w-[320px] h-[320px] md:w-[450px] md:h-[450px] border border-gold/20 rounded-full"
          />

          <motion.div
            animate={{
              rotate: -360,
            }}
            transition={{
              duration: 35,
              repeat: Infinity,
              ease: "linear",
            }}
            className="absolute w-[260px] h-[260px] md:w-[380px] md:h-[380px] border border-gold/10 rounded-full"
          />

          <div className="relative z-10 flex flex-col items-center">
            {/* SEIF */}
            <div className="overflow-hidden">
              <motion.h1
                initial={{ y: 120 }}
                animate={{ y: 0 }}
                transition={{
                  duration: 1,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="text-5xl md:text-8xl font-black tracking-[0.15em] text-white"
              >
                SEIF
              </motion.h1>
            </div>

            {/* ELSHEMY */}
            <div className="overflow-hidden">
              <motion.h1
                initial={{ y: 120 }}
                animate={{ y: 0 }}
                transition={{
                  duration: 1,
                  delay: 0.15,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="text-5xl md:text-8xl font-black tracking-[0.15em] text-gold"
              >
                ELSHEMY
              </motion.h1>
            </div>

            {/* Subtitle */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{
                delay: 0.8,
                duration: 1,
              }}
              className="mt-4 text-[11px] md:text-sm tracking-[0.5em] uppercase text-white/60"
            >
              Frontend Engineer
            </motion.p>


            {/* Progress */}
            <div className="mt-12 w-[220px] md:w-[320px]">
              <div className="h-[2px] bg-white/10 rounded-full overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  animate={{ width: `${progress}%` }}
                  transition={{
                    ease: "linear",
                  }}
                  className="h-full bg-gold"
                />
              </div>

              <div className="flex justify-between mt-3">
                <span className="text-white/40 text-xs tracking-widest">
                  LOADING
                </span>

                <span className="text-gold text-xs tracking-widest">
                  {progress}%
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;